export const TEXT_PAGE_SECTION_ITEM_TYPE = {
  LINKS: 'LINKS',
  TABLE: 'TABLE',
  LINK: 'LINK',
  TEXT: 'TEXT',
} as const;
